import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type AddEfsaSampnt, useAuth } from 'prove-common'
import { requireSuccessfulResponse } from './referenceErrors'

export function useUpdateSamplingSiteMutation() {
  const { authFetch } = useAuth()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      sampntId,
      body
    }: {
      sampntId: number
      body: AddEfsaSampnt
    }) => {
      const result = await authFetch().PUT('/efsa/sampnt/{sampntId}', {
        params: { path: { sampntId } },
        body
      })
      requireSuccessfulResponse(result)
      return result.data
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['sampntTypes'] })
  })
}
